import { useHandleQueryErrorWithToast } from '@/features/shiftCloseouts/hooks/useHandleQueryErrorWithToast'
import { ShiftCloseoutPreviewQuery } from '@/features/shiftCloseouts/queries'
import { DailyShiftCloseout } from '@/features/shiftCloseouts/types'
import { transformShiftCloseoutPreview } from '@/features/shiftCloseouts/utils/transformShiftCloseoutPreview'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

interface UseShiftCloseoutPreviewResult {
    loading: boolean
    shiftCloseout?: DailyShiftCloseout
}

export const useShiftCloseoutPreview = (): UseShiftCloseoutPreviewResult => {
    const { data, error, loading } = useQuery(ShiftCloseoutPreviewQuery, {
        fetchPolicy: 'network-only',
    })

    useHandleQueryErrorWithToast(error, loading)

    const shiftCloseout = useMemo(
        () =>
            data
                ? transformShiftCloseoutPreview(data.shiftCloseoutPreview, data.currentTime)
                : undefined,
        [data]
    )

    return { loading, shiftCloseout }
}
